import React, { Component } from 'react'
import './Header.css'
import logo from '../img/OLPI-Logo-White.png'
import { Navbar, Nav, NavItem } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'
import { Link } from 'react-router'

class Header extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    return (
      <header id="header" className="header" >
        <div >
          <Navbar inverse collapseOnSelect fluid>
            <Navbar.Header>
              <Navbar.Brand>
                <Link to="/"><img className="small-logo" src={logo} alt="logo"/></Link>
              </Navbar.Brand>
              <Navbar.Toggle />
            </Navbar.Header>
            <Navbar.Collapse  >
              <Nav pullRight >
                <LinkContainer to="/faqs">
                  <NavItem eventKey={1}>FAQs</NavItem>
                </LinkContainer>
                <LinkContainer to="/whatif">
                  <NavItem eventKey={2} >What If</NavItem>
                </LinkContainer>
                <LinkContainer to="/research">
                  <NavItem eventKey={3} >Research</NavItem>
                </LinkContainer>
                <LinkContainer to="/about">
                  <NavItem eventKey={4} >About Us</NavItem>
                </LinkContainer>
              </Nav>
            </Navbar.Collapse>
          </Navbar>
        </div>
      </header>
    );
  }

}

export default Header;



/** WEBPACK FOOTER **
 ** ./src/components/Header.js
 **/